import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import SolicitacaoArquivos from 'containers/Forms/FormServicoDuvida/arquivos';
import Servico from './servico';
import Endereco from 'components/Endereco';
import Justificativa from './justificativa';
import { verificarDuplicidade } from './FormServicoDuvida';
import * as S from '../styles';
import * as Style from 'components/Style';
import FormPessoa from 'containers/Forms/FormPessoa';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export default function FormPadrao({
  control,
  onChange,
  errors,
  setValue,
  getValues,
  watch,
  setError,
  salvarAquivos,
  tipoFormulario,
  disabled,
  dadosServico,
  setDadosServico,
}) {
  const dispatch = useDispatch();

  const inputDadosCadastrais = useSelector(state => state.inputs.inputDadosCadastrais);
  const user = useSelector(state => state.sefaz.userProfile);

  const verificarRepeticao = documento => {
    dispatch(verificarDuplicidade(documento, getValues()));
  };

  const disabledChangePessoa = () => {
    const inputCarregado = inputDadosCadastrais?.tipoPessoa && user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE;
    return disabled || inputCarregado;
  };

  return (
    <S.Contain>
      <Style.GlobalCard>
        <Servico
          control={control}
          onChange={onChange}
          errors={errors}
          tipoFormulario={tipoFormulario}
          setDadosServico={setDadosServico}
          verificarRepeticao={verificarRepeticao}
        />
        <FormPessoa
          control={control}
          onChange={onChange}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          setError={setError}
          disabled={disabled}
          verificarRepeticao={verificarRepeticao}
          disableDocumento={disabledChangePessoa()}
        />
        <Endereco
          titulo="Endereço"
          control={control}
          onChange={onChange}
          errors={errors}
          setValue={setValue}
          setError={setError}
          disabled={disabled}
        />
        <Justificativa control={control} onChange={onChange} errors={errors} />
        <SolicitacaoArquivos
          salvarAquivos={salvarAquivos}
          servicoSelecionado={dadosServico}
          documentos={dadosServico?.documentos}
          erroArquivos={errors['arquivos']?.message}
        />
      </Style.GlobalCard>
    </S.Contain>
  );
}

FormPadrao.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  getValues: PropTypes.func,
  setError: PropTypes.func,
  salvarAquivos: PropTypes.func,
  disabled: PropTypes.bool,
};
